import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import FormActions from '../../../components/form/FormActions.tsx';
import Table from '../../../components/Table.tsx';
import { useAlimentsContext } from '../../../contexts/aliments/aliments.tsx';

const AlimentsBody = () => {
  const { aliments, deleteAliment } = useAlimentsContext();
  const navigate = useNavigate();
  const columns = [
    {
      header: "name",
      name: "name",
      enableSorting: true,
      cell: (props: any) => {
        const { alimentID, name } = props.row;
        return (
          <Link className="nav-link" to={`/aliments/${alimentID}`}>
            <span >{name}</span>
          </Link>
        );
      }
    },
    {
      header: "published",
      name: "isPublished",
      enableSorting: false,
    },
    {
      header: "validated",
      name: "isValidated",
      enableSorting: false,
    },
    {
      header: "",
      name: "delete",
      actionHandler: (props: any) => {
        const { alimentID } = props.row;
        return deleteAliment(alimentID);
      },
      enableSorting: false
    }
  ]

  return (
    <>
      <Table columns={columns} rows={aliments} />
      <FormActions
        mainAction={() => { navigate("/aliments/create"); }}
        mainActionText="Create"
      />
    </>
  );
};

export default AlimentsBody;